export default __webpack_public_path__ + "static/space-scheda-tecnica-8452320b21861dbbf50dcceae5f950ee.pdf";